<template>
  <div class="page">
    <c-source-page
      :table="table"
      :columns="columns"
      :filter="filter"
      :pagination="pagination"
      resource="products"
      createButtonText="新建产品"
      :batchActions="batchActions"
    />
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
import createColumns from './columns';
import { permissionService } from 'beans-admin-plugin';
import _ from 'lodash';
import ChooseCategory from './choose-category';

@Component
export default class Products extends Vue {

  pagination = {}

  filter = [
    {
      prop: 'shop_i_id_cont',
      label: '货号',
      form: {
        component: 'search'
      }
    },
    {
      prop: 'name_cont',
      label: '产品名',
      form: {
        component: 'search'
      }
    },
    {
      prop: 'categories_name_cont',
      label: '分类',
      form: {
        component: 'search'
      }
    },
    // TODO
    // {
    //   prop: 'series_name_cont',
    //   label: '系列',
    //   form: {
    //     component: 'select'
    //   }
    // },
    {
      prop: 'enabled_eq',
      label: '是否发布',
      form: {
        component: 'select',
        props: {
          clearable: true,
          options: [
            {
              label: '是',
              value: true
            },
            {
              label: '否',
              value: false
            }
          ]
        }
      }
    },
    {
      prop: 'is_sell_out_filter_in',
      label: '是否售罄',
      form: {
        component: 'select',
        props: {
          clearable: true,
          options: [
            {
              label: '是',
              value: true
            },
            {
              label: '否',
              value: false
            }
          ]
        }
      }
    }
  ]

  table = {
    data: []
  };

  categories= [];
  categoryIds = [];

  get columns() {
    return createColumns({
      action: {
        fixed: 'right',
        width: 100,
        detail: true
      },
      handleDeleted: this.fetchData,
      handleRefresh: this.fetchData
    });
  }

  async mounted() {
    this.fetchData();
  }

  async fetchData(params = {}) {
    const [{ data, pagination }, { data: categories }] = await Promise.all([
      this.$request.get('/products', { params: { ...this.$route.query, ...params } }),
      this.$request.get('/categories', { params: { per_page: 100, simple_list: true } }),
    ]);
    this.table.data = data;
    this.pagination = pagination;
    this.categories = categories;
  }

  get batchActions() {
    return [
      {
        text: '上架',
        permission: 'products.update',
        handler: async (products) => {
          await this.$confirm('确定上架所选产品？', '上架产品');
          await this.$request.put('/products/publish', { product_ids: _.map(products, 'id') });
          this.$message.success('上架成功');
          this.fetchData();
        }
      },
      {
        text: '下架',
        permission: 'products.update',
        handler: async (products) => {
          await this.$confirm('确定下架所选产品？', '下架产品');
          await this.$request.put('/products/unpublish', { product_ids: _.map(products, 'id') });
          this.$message.success('下架成功');
          this.fetchData();
        }
      },
      this.categories.length && {
        text: '设置分类',
        permission: 'products.update',
        handler: async (products) => {
          this.$msgbox({
            title: '设置分类',
            message: <ChooseCategory categories={this.categories} initCategoryIds={[]} onChange={val => this.categoryIds = val} />,
            showCancelButton: true,
            confirmButtonText: '确定',
            cancelButtonText: '取消'
          }).then(() => {
            this.setCategories(_.map(products, 'id'))
          });
        }
      }
    ].filter(item => item && permissionService.hasPermission(item.permission))
  }

  async setCategories(product_ids) {
    await this.$request.put('/products/set_categories', { product_ids: product_ids, category_ids: this.categoryIds, single_product: false });
    this.$message.success('更新成功');
    this.fetchData();
  }
}
</script>

<style lang="scss" scoped>
  /deep/ .source-page-btn-group {
    button {
      margin-right: 10px !important;
      margin-left: 0;
    }
  }
</style>
